module.exports = __webpack_public_path__ + "img/banner-faq.1bba0378.jpg";